/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "react-flexbox-layout/lib/styles.css";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";

import { useOnFirstRender } from "@web-monorepo/hooks";
import { useTranslation } from "@web-monorepo/i18next";
import { useParams } from "react-router-dom";
import GroupsRemoteContainer from "src/pods/groups/components/GroupsRemoteContainer";
import DirectionsRemoteContainer from "src/pods/list/components/DirectionsRemoteContainer";
import NoiseRemoteContainer from "src/pods/noise/components/NoiseRemoteContainer";
import PairShareContainer from "src/pods/pairshare/components/sender/PairShareContainer";
import RadioRemoteContainer from "src/pods/radio/components/RadioRemoteContainer";
import RandomRemoteContainer from "src/pods/random/components/RandomRemoteContainer";
import TimerRemoteContainer from "src/pods/timer/components/TimerRemoteContainer";
import TodaySetupContainer from "src/pods/today/components/sender/TodaySetupContainer";
import { metrics } from "src/utils/metrics";

export default function ToolkitAppRemote() {
  // this tells i18next to load these namespaces
  const { ready } = useTranslation(["dojo.toolkit", "dojo.common"]);
  const params = useParams();
  let Component: React.ComponentType<any> | null = null;
  if (params.app === "pairshare") {
    Component = PairShareContainer;
  } else if (params.app === "today") {
    Component = TodaySetupContainer;
  } else if (params.app === "list") {
    Component = DirectionsRemoteContainer;
  } else if (params.app === "timer") {
    Component = TimerRemoteContainer;
  } else if (params.app === "radio") {
    Component = RadioRemoteContainer;
  } else if (params.app === "noise") {
    Component = NoiseRemoteContainer;
  } else if (params.app === "random") {
    Component = RandomRemoteContainer;
  } else if (params.app === "groups") {
    Component = GroupsRemoteContainer;
  } else {
    throw new Error(`Invalid app: ${params.app}`);
  }

  useOnFirstRender(() => {
    metrics.increment(`remote.${params.app}.open`);
  });

  return (ready || null) && <Component params={params} />;
}
